import(/* webpackMode: "eager" */ "/build/bcb5887a-4c8f-4e2d-86fe-16ead6d49f0d/src/app/global-error.tsx");
